import type { ResolutionString } from "~/chart";

export type PortfolioTimeframe = "1Min" | "5Min" | "15Min" | "1H" | "1D";
export type PortfolioPeriod = "1D" | "1W" | "1M" | "1A" | "all";
export type PortfolioLookback = "1D" | "1W" | "1M" | "1Y" | "ALL";

export interface PortfolioLookbackOption {
  intradayReporting: "market_hours" | "extended_hours" | "continuous";
  comparisonResolution: ResolutionString;
  historyMonths?: number;
  label: string;
  period: PortfolioPeriod;
  timeframe?: PortfolioTimeframe;
  value: PortfolioLookback;
}

export const PORTFOLIO_LOOKBACKS: readonly PortfolioLookbackOption[] = [
  {
    comparisonResolution: "1" as ResolutionString,
    intradayReporting: "continuous",
    label: "1D",
    period: "1D",
    timeframe: "1Min",
    value: "1D",
  },
  {
    comparisonResolution: "1" as ResolutionString,
    intradayReporting: "extended_hours",
    label: "1W",
    period: "1W",
    timeframe: "1Min",
    value: "1W",
  },
  {
    comparisonResolution: "60" as ResolutionString,
    historyMonths: 1,
    intradayReporting: "extended_hours",
    label: "1M",
    period: "1A",
    timeframe: "1D",
    value: "1M",
  },
  {
    comparisonResolution: "1D" as ResolutionString,
    intradayReporting: "extended_hours",
    label: "1Y",
    period: "1A",
    timeframe: "1D",
    value: "1Y",
  },
  {
    comparisonResolution: "1D" as ResolutionString,
    intradayReporting: "extended_hours",
    label: "ALL",
    period: "all",
    value: "ALL",
  },
];

export const DEFAULT_PORTFOLIO_LOOKBACK: PortfolioLookback = "1Y";

export const getPortfolioLookbackOption = (lookback: PortfolioLookback) =>
  PORTFOLIO_LOOKBACKS.find((option) => option.value === lookback) ??
  PORTFOLIO_LOOKBACKS[0];

export const INITIAL_PORTFOLIO_RESOLUTION = "1" as ResolutionString;

export const PORTFOLIO_TIMEFRAMES: Record<string, PortfolioTimeframe> = {
  "1": "1Min",
  "5": "5Min",
  "15": "15Min",
  "60": "1H",
  "1D": "1D",
};
